// extracted by mini-css-extract-plugin
export default {"double":"valuehybrid_double__cIELw","doubleInput":"valuehybrid_doubleInput__IBapo"};